import {
    IDotRezPartialBookingSessionData
} from "../../../../dot-rez-api/data-contracts/booking/dot-rez-booking-session-data.interface";
import {SellJourneyBundleMutation} from "./sell-journey-bundle.mutation";
import {IDotRezSellJourneyBundleRequest} from "../../../../dot-rez-api/data-contracts/requests/booking/sell-bundle.request";
import {BookingModel} from "../../booking.model";
import {IBundleSsrUpgradePair} from "../../bundle/bundle-ssr-upgrade.model.interface";

export class SellDepartureJourneyBundleMutation extends SellJourneyBundleMutation {
    constructor(booking: BookingModel,
                bundleCodeToSell: string,
                private readonly bundleSsrsUpgradesPairs: IBundleSsrUpgradePair[]) {
        super(booking, bundleCodeToSell)

    }
    
    async _runMutation(): Promise<IDotRezPartialBookingSessionData> {

        if(!this.booking.departureJourney) {
            throw new Error('You must first sell departure journey before selling a bundle for it');
        }

        let journeysToSellTheBundleFor: IDotRezSellJourneyBundleRequest[] = [];
        let sellBundleForOneJourneyRequest = this._createJourneySellBundleRequest(this.booking.departureJourney, this.bundleSsrsUpgradesPairs);

        journeysToSellTheBundleFor = [...sellBundleForOneJourneyRequest.requests];
        let ssrKeysToRemoveOnBundleChange = sellBundleForOneJourneyRequest.ssrKeysToRemove;

        if(this.booking.returnJourney?.selectedBundle) {// if there is already a bundle selected for the return journey we want to keep it in sync with the departure journey bundle
            sellBundleForOneJourneyRequest = this._createJourneySellBundleRequest(this.booking.returnJourney, this.bundleSsrsUpgradesPairs);
            journeysToSellTheBundleFor = [
                ...journeysToSellTheBundleFor,
                ...sellBundleForOneJourneyRequest.requests
            ];
            ssrKeysToRemoveOnBundleChange = [
                ...ssrKeysToRemoveOnBundleChange,
                ...sellBundleForOneJourneyRequest.ssrKeysToRemove

            ];
        }

        await this.session.sellBundle({
            journeys: journeysToSellTheBundleFor,
            ssrKeysToRemove: ssrKeysToRemoveOnBundleChange.distinct(key => key)
        });

        return await this.session.bookingStateQueryBuilder().useBookingData().getBookingState();
    }

    async onAfterBookingSessionDataUpdated(): Promise<void> {
        await super.onAfterBookingSessionDataUpdated();
        setTimeout(  ()=> {
            this.services.analytics.flightSelectionEvents.logAddToCartForDeparture(this.booking);
        })

    }
}
